export const my_portal_header = {
  page_title: "My Portal",
  page_subtitle:
    "Every part you've listed, sold, and shipped through PAX — in one place.",
  sell_a_part: "Sell a Part",
};
